import { useContext, useEffect, useState } from "react";

export const useBislabTermsModal = (messages, onAccept, fetchTerms, base64) => {

    const [dialogVisible, setDialogVisible] = useState(false)
    const shouldFetch = !base64 || base64 === '';

    const cancelHandler = e => {
        setDialogVisible(false)
    }

    const acceptHandler = e => {
        onAccept()
        setDialogVisible(false)
        
    }

    const showDialog = async () => {
        if (shouldFetch) {
            await fetchTerms();
        }
        setDialogVisible(true);
    };

    return {dialogVisible, showDialog, cancelHandler, messages, acceptHandler, shouldFetch}

}